<template>
  <div class="second-node">
    <div class="main-wrap">
      <div id="main-content">
        <div class="wrapper">
          <jm-crumbs/>
          <div class="basic-title"><em>节点信息</em></div>
          <el-row class="padding8">
            <el-col :span="24">
              <el-select
                @change="getData"
                clearable
                class="jm-input135"
                v-model="countryId"
                placeholder="请选择">
                <el-option
                  v-if="countryList.length <= 0"
                  label="请选择"
                  value="0"
                  key="0"/>
                <el-option
                  v-for="(selitem, key) in countryList"
                  :label="selitem"
                  :value="key"
                  :key="key"/>
              </el-select>
              &nbsp;
              <el-button
                v-permission="[1]"
                @click="addNode"
                type="primary">添加节点</el-button>
              <el-button
                v-permission="[1]"
                @click="allNode"
                type="success">{{ textNode }}</el-button>
              <el-button
                @click="resetNode"
                type="danger">刷新用户节点</el-button>
            </el-col>
          </el-row>
          <el-row class="padding8 table-agile-info ">
            <el-col :span="24">
              <el-collapse v-model="activeNames">
                <el-collapse-item
                  v-for="(item, index) in formData"
                  :key="item.id"
                  :name="index">
                  <template slot="title">
                    <div
                      class="jm-show"
                      @click.stop>
                      <span>排序权重：</span>
                      <el-input
                        v-model="item.rank"
                        size="mini"
                        class="jm-input50"/>
                    </div>
                    <span>&emsp;{{ item.title }}  <i v-if="item.is_all === 1">★</i></span>
                    <el-button
                      v-permission="[1]"
                      v-if="item.status == 0"
                      @click.stop="editNode(item.id, 1)"
                      class="title-right"
                      type="success"
                      icon="circle-check"
                      size="mini">恢复</el-button>
                    <el-button
                      v-permission="[1]"
                      v-if="item.status == 1"
                      @click.stop="editNode(item.id, 0)"
                      class="title-right"
                      type="danger"
                      icon="delete"
                      size="mini">删除</el-button>
                    <el-button
                      @click.stop="idSend(item.id)"
                      class="title-right"
                      type="primary"
                      icon="edit"
                      size="mini">编辑</el-button>
                  </template>
                  <div class="second-node-card">
                    <span
                      v-for="item2 in item.article_list"
                      class="content"
                      :key="item2.title">
                      <h3>{{ item2.title }}</h3>
                      <p>{{ item2.title_sub }}</p>
                      <a
                        target="_blank"
                        :href="item2.url">查看详情</a>
                    </span>
                  </div>
                </el-collapse-item>
              </el-collapse>
            </el-col>
          </el-row>
          <el-row class="padding8">
            <el-col :span="24">
              <el-button
                @click="listSave"
                type="primary">保存</el-button>
            </el-col>
          </el-row>
          <jm-secondNodeEdit
            :hidden-btn.sync="windowH"
            :node-id="editId"
            :country-id="countryId"
            v-if="windowH"/>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import crumbs from '@/components/tool/crumbs';
import secondNodeEdit from '@/components/tool/secondNodeEdit';

export default {
  data() {
    return {
      formData: {},
      activeNames: 0,
      windowH: false,
      countryId: 0,
      countryList: [],
      editId: 0,
      nodeList: 0,
      textNode: '显示可恢复节点'
    };
  },
  components: {
    'jm-crumbs': crumbs,
    'jm-secondNodeEdit': secondNodeEdit
  },
  methods: {
    getData() {
      this.$http._get({
        url: `/index/Second_sales/getList?is_repair=${this.nodeList}&country_id=${this.countryId}`
      }).then((data) => {
        console.log(data.data.country);
        if (this.countryId === 0) {
          let keyList = Object.keys(data.data.country);
          this.countryId = keyList[0];
        }
        this.countryList = data.data.country;
        this.formData = data.data.data;
      });
    },
    listSave() {
      let listData = {
        ...this.formData
      };
      this.$http._post({
        url: '/index/Second_sales/setOrder',
        data: { rank: listData },
      }).then(() => {
        this.$message.success('保存成功');
        this.getData();
      });
    },
    idSend(val) {
      this.editId = val;
      this.windowH = !this.windowH;
    },
    addNode() {
      this.editId = 0;
      this.windowH = !this.windowH;
    },
    editNode(val, num) {
      this.$http._post({
        url: '/index/Second_sales/setStatus',
        data: { id: val, status: num },
      }).then(() => {
        if (num === 0) {
          this.$message.error('删除成功');
        } else {
          this.$message.success('恢复成功');
        }
        this.getData();
      });
    },
    allNode() {
      if (this.nodeList === 0) {
        this.nodeList = 1;
        this.textNode = '隐藏可恢复节点';
        this.getData();
      } else {
        this.nodeList = 0;
        this.textNode = '显示可恢复节点';
        this.getData();
      }
    },
    resetNode() {
      this.$http._get({
        url: `/index/Second_sales/refresh?country_id=${this.countryId}`
      }).then(() => {
        this.$message.success('刷新成功');
      });
    }
  },
  mounted() {
    this.getData();
  },
};
</script>
<style scoped>
  .padding8{
    padding:8px;
  }
  .second-node-card{
    width: 100%;
    overflow-x: auto;
    white-space: nowrap;
    padding-bottom: 10px;
  }
  .second-node-card .content{
    display: inline-block;
    border: 1px solid #dfe6ec;
    -webkit-border-radius: 10px; -moz-border-radius: 10px; border-radius: 10px;
    padding: 10px;
    width: 360px;
    margin-right: 10px;
    white-space: normal;
  }
  .second-node-card .content p{
    height:72px;
    line-height:24px;
  }
  .second-node-card .content a{
    display: inline-block;
    background: #20a0ff;
    color:#fff;
    margin-top: 10px;
    padding:5px 10px;
    -webkit-border-radius: 4px; -moz-border-radius: 4px; border-radius: 4px;
  }
  .title-right{
    float: right;
    margin: 10px 15px 0 0
  }
</style>
